import { render, staticRenderFns } from "./Dashboard-unfiltered.vue?vue&type=template&id=581d22f4&scoped=true"
import script from "./Dashboard-unfiltered.vue?vue&type=script&lang=js"
export * from "./Dashboard-unfiltered.vue?vue&type=script&lang=js"
import style0 from "./Dashboard-unfiltered.vue?vue&type=style&index=0&id=581d22f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581d22f4",
  null
  
)

export default component.exports